import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import App from "App";

const el = document.getElementById("services");

const app = createApp(App, {
	org: JSON.parse(el.dataset.org),
	userId: el.dataset.userId || null,
	now: Number(el.dataset.now)
});

app.use(i18n);
app.use(vui);

app.mount(el);
